const getURLParams = () => {
  const { search } = window.location;

  if (!search) return {};

  const string = decodeURIComponent(search).substr(1);
  const array = string.split('&');
  const obj: any = {};

  array.forEach(pair => {
    const subArray = pair.split('=');
    const key = subArray[0];
    const value = subArray[1];
    obj[key] = value;
  });
  return obj;
};

export default getURLParams;
